import { checkIsImpoundCollected, getSchedule } from 'utils/impounds';

export const getCollectedImpoundsSchedule = ({
  impoundsData,
  taxesInsuranceEscrowed,
  prepaidInterestCreditFirstPaymentDate,
}) =>
  prepaidInterestCreditFirstPaymentDate
    ? getSchedule({
        ...impoundsData,
        impounds: impoundsData.impounds.filter(impound =>
          checkIsImpoundCollected(impound, taxesInsuranceEscrowed),
        ),
        prepaidInterestCreditFirstPaymentDate,
      })
    : {};
